// Splits a single "name" string into { firstName, lastName } for forms that
// migrated from one combined field to separate first/last inputs. Only the
// first word becomes firstName; everything else becomes lastName.
export const splitName = (name) => {
  const trimmed = (name || "").trim();
  if (!trimmed) return { firstName: "", lastName: "" };
  const parts = trimmed.split(/\s+/);
  return {
    firstName: parts[0],
    lastName: parts.slice(1).join(" "),
  };
};

// Recombines firstName/lastName into the single "name" string still relied
// on by lists, search, sort, and exports across the app.
export const joinName = (firstName, lastName) =>
  [firstName, lastName].map((s) => (s || "").trim()).filter(Boolean).join(" ");

// "Lastname, Firstname" for dropdowns/lists sorted by last name. Prefers the
// separate firstName/lastName fields and falls back to splitting "name";
// a single-word name is returned as-is with no dangling comma. Some older
// records (e.g. InstructorArchive) already store "name" as "Last, First",
// so that form is kept rather than flipped a second time.
export const formatLastFirst = ({ firstName, lastName, name } = {}) => {
  if (!firstName && !lastName && (name || "").includes(",")) {
    return name
      .split(",")
      .map((part) => part.trim())
      .filter(Boolean)
      .join(", ");
  }
  const split = splitName(name);
  const first = (firstName || split.firstName || "").trim();
  const last = (lastName || split.lastName || "").trim();
  if (first && last) return `${last}, ${first}`;
  return last || first;
};
